<template>
    <a-card :bordered="false" class="dashboard-bar-chart">
        <a-tabs>
            <a-tab-pane key="1" tab="Inprogress" v-if="isEnabled">
                <orders-list :ordersSource="inprogressOrders"/>
            </a-tab-pane>
            <a-tab-pane key="2" tab="Pending" v-if="isEnabled">
                <orders-list :ordersSource="pendingOrders"/>
            </a-tab-pane>
            <a-tab-pane key="3" tab="Scheduled" v-if="isEnabled">
                <orders-list :ordersSource="scheduledOrders"/>
            </a-tab-pane>
            <a-tab-pane key="4" tab="Unmanaged">
                <orders-list :ordersSource="unmanagedOrders"/>
            </a-tab-pane>
            <a-tab-pane key="5" tab="Ready">
                <orders-list :ordersSource="readyOrders"/>
            </a-tab-pane>
        </a-tabs>
    </a-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import OrdersList from './OrdersList.vue'
export default {
    components : {
        OrdersList
    },
    computed : {
        ...mapState({
            isEnabled : state => state.orderManager.orderManagerState.isEnabled
        }),
        ...mapGetters({
            unmanagedOrders : 'orderManager/unmanagedOrders',
            pendingOrders : 'orderManager/pendingOrders',
            scheduledOrders : 'orderManager/scheduledOrders',
            readyOrders : 'orderManager/readyOrders',
            inprogressOrders : 'orderManager/inprogressOrders',
            cancelledOrders : 'orderManager/cancelledOrders',
            totalInprogressOrders : 'orderManager/totalInprogressOrders',
            totalPendingOrders : 'orderManager/totalPendingOrders',
            totalScheduledOrders : 'orderManager/totalScheduledOrders',
            totalReadyOrders : 'orderManager/totalReadyOrders',
            totalUnmanagedOrders : 'orderManager/totalUnmanagedOrders',
            totalCancelledOrders : 'orderManager/totalCancelledOrders'
       	}),
        
    },
    data() {
        return {
            orderType : 0,
        }
    },

    methods : {
        handleOrderTypeChanged(e) {
            console.log(e)
        },
    }
}
</script>